var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3523_25169)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 72,
    r: 60,
    fill: "#38879F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0019 50.2051C63.9929 50.2051 54.207 59.991 54.207 71.9999C54.207 84.0089 63.9929 93.7948 76.0019 93.7948C88.0109 93.7948 97.7968 84.0089 97.7968 71.9999C97.7968 59.991 88.0109 50.2051 76.0019 50.2051ZM86.4198 66.9871L74.0622 79.3448C73.757 79.6499 73.3429 79.8243 72.907 79.8243C72.4711 79.8243 72.057 79.6499 71.7519 79.3448L65.584 73.1769C64.9519 72.5448 64.9519 71.4987 65.584 70.8666C66.216 70.2346 67.2622 70.2346 67.8942 70.8666L72.907 75.8794L84.1096 64.6769C84.7416 64.0448 85.7878 64.0448 86.4198 64.6769C87.0519 65.3089 87.0519 66.3333 86.4198 66.9871Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3523_25169",
    x: 0,
    y: 0,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3523_25169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3523_25169",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCard);
export default __webpack_public_path__ + "static/media/tick-card.c531cd7a76599f72055f7e9cbcc091a3.svg";
export { ForwardRef as ReactComponent };